
export const i1yz = {
  i1yr: { // 抽選 履歴管理対象外
    v0: {
      itlz: {
        i1yr_31r1f: -1,
        i1yrd1100s: '',
        i1yrd2100s: '',
        i1yrs1100i: -1,
      },
      unqs: [
        'i1yr_31r1f',
        'i1yrd1100s',
      ],
      fldz: {
        i1yr_31r1f: {
          pfx: '施設'
        },
        i1yrd1100s: {
          pfx: '利用日',
        },
        i1yrd2100s: {
          pfx: '抽選日'
        },
        i1yrs1100i: {
          pfx: '抽選状況',
          ls: [
            { key: -1, pfx: '未抽選' },
            { key:  1, pfx: '抽選済' },
          ]
        },
        i1yrs1200i: {
          pfx: '登録状況',
          ls: [
            { key: -1, pfx: '未登録' },
            { key:  1, pfx: '登録済' },
          ]
        },
        i1yra1100i: {
          pfx: 'エントリー数',
/*
          atrs: [
            {
              qry: `
                INSERT INTO
                  i1yrs
                (
                  _dmn,
                  i1yr_31r1f,
                  i1yrd1100s,
                  i1yrs1100i,
                  "createdAt",
                  "updatedAt"
                ) VALUES (
                  {i1zr_dmn},
                  {i1zr_31r1f},
                  '{i1zrd3100s}',
                  -1,
                  now(),
                  now()
                )
                ON CONFLICT ON CONSTRAINT i1yr_unq1
                DO NOTHING
              `,
              rlcz: {
                i1zr_dmn: 'i1zrs._dmn',
                i1zr_31r1f: 'i1zrs.i1zr_31r1f',
                i1zrd3100s: 'i1zrs.i1zrd3100s'
              },
            },
            {
              qry: `
                UPDATE
                  i1yrs
                SET
                  i1yra1100i = (
                    SELECT
                      COUNT(*)
                    FROM
                      i1zrs
                    WHERE
                      COALESCE(_dlt,-1)<>1
                      AND _vsn=_ltt
                      AND i1zr_31r1f=i1yr_31r1f
                      AND i1zrs1200i>=70
                      AND i1zrd3100s=i1yrd1100s
                  )
                WHERE
                  COALESCE(_dlt,-1)<>1
                  AND i1yr_31r1f={i1zr_31r1f}
                  AND i1yrd1100s='{i1zrd3100s}'
              `,
              rlcz: {
                i1zr_31r1f: 'i1zrs.i1zr_31r1f',
                i1zrd3100s: 'i1zrs.i1zrd3100s'
              },
            },
          ]
*/
        },
      },
    },
  },
};
